import { render, staticRenderFns } from "./RequestResetPasswordPage.vue?vue&type=template&id=41229f7d&scoped=true&"
import script from "./RequestResetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./RequestResetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestResetPasswordPage.vue?vue&type=style&index=0&id=41229f7d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41229f7d",
  null
  
)

export default component.exports